module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-36.58105c80.png";